import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_529e1c3e9c24486707947729ac40a4e3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}